import createActions from 'utils/redux/createActions'

export default createActions([
	'TASK_FILTER_UPDATED'
  , 'CLEAR_TASK_FILTERS'
])



// WEBPACK FOOTER //
// ./src/actions/taskFilters.js